import dayjs from "dayjs";
import { ICampaignInfo } from "@/Models/ApiModels";
import { getDateListFromOrderKeywords } from "@/entities/new-order/utils";
import { DATE_FORMAT } from "@/Utils/DateUtils";
import { getDatesBetween } from "@/shared/helpers";
import { getParsedExtendCountries } from "./get-parsed-extend-contries";

/**
 * Формирует черновик для продления заказа
 * @param campaign - информация о кампании с сервера
 * @returns объект с датами, настройками и списком стран для нового заказа
 */
export const getExtendDraft = (campaign: ICampaignInfo) => {
  const oldDateList = getDateListFromOrderKeywords(campaign.keywords);

  const oldEndDate = dayjs(oldDateList[oldDateList.length - 1], DATE_FORMAT);

  // Используем локальную дату без UTC-сдвига
  const nowDate = dayjs().startOf("day");

  // Заказ считается активным, если текущая дата <= конечной старой даты
  const isOrderActive =
    nowDate.isBefore(oldEndDate, "day") || nowDate.isSame(oldEndDate, "day");

  // Новый старт ВСЕГДА считается от oldEndDate
  const newStartDate = isOrderActive
    ? oldEndDate.add(1, "day").format(DATE_FORMAT)
    : nowDate.format(DATE_FORMAT);

  const oldOrderDurationDays = oldDateList.length;

  const newEndDate = dayjs(newStartDate, DATE_FORMAT)
    .add(oldOrderDurationDays - 1, "day")
    .format(DATE_FORMAT);

  const newDateArray = getDatesBetween(newStartDate, newEndDate);

  const delayed_start = Boolean(campaign.delayed_start);
  const delayedStartValue = campaign.delayed_start || null;

  const countriesList = getParsedExtendCountries(
    campaign,
    newDateArray,
    oldDateList,
  );

  return {
    dateStart: newStartDate,
    dateStop: newEndDate,
    delayed_start,
    delayedStartValue,
    countriesList,
  };
};
